module.exports = __webpack_public_path__ + "static/media/emojis_03.87fd0239.svg";